import { Grid2 } from "@mui/material";
import React from "react";
import Calendar from "./Calendar";
import BusinessCase from "./BusinessCase";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

const Courses = () => {
  return (
    <Grid2 sx={styles}>
      <Calendar />
      <BusinessCase />
    </Grid2>
  );
};

export default Courses;
